import { setSessionStorageItem, getSessionStorageItem } from '../../sessionStorage/utils';
import {
  SESSION_STORAGE_BOOKING_TOKEN_NAME,
  SESSION_STORAGE_BOOKING_PROFILE_NAME,
} from '../../../utils/constants';

const saveBookingProfile = (bookingProfileToSave, bookingProfileVar) => {
  setSessionStorageItem(SESSION_STORAGE_BOOKING_PROFILE_NAME, bookingProfileToSave);
  bookingProfileVar(bookingProfileToSave);
};

/* We can add multiple ways of updating a variable. The side effects can be added here too */
export const createSetBookingProfile = (bookingProfileVar) => {
  return (newBookingProfile) => {
    const currentBookingProfile = bookingProfileVar();
    const filteredAirportsObject = {
      nodes: newBookingProfile?.airports?.nodes,
    };
    saveBookingProfile(
      {
        bookingToken:
          currentBookingProfile?.bookingToken ||
          getSessionStorageItem(SESSION_STORAGE_BOOKING_TOKEN_NAME, false) ||
          '',
        bookingType:
          currentBookingProfile && currentBookingProfile.bookingType
            ? currentBookingProfile.bookingType
            : '',
        airports: filteredAirportsObject,
        flightProfile: newBookingProfile.flightProfile,
        currentBooking: newBookingProfile.currentBooking,
      },
      bookingProfileVar,
    );
  };
};

export const createSetBookingToken = (bookingProfileVar) => {
  return (newBookingToken) => {
    saveBookingProfile(
      { bookingToken: newBookingToken, airports: null, flightProfile: null },
      bookingProfileVar,
    );
  };
};

export const createSetBookingEmail = (bookingProfileVar) => {
  return (newBookingEmail) => {
    saveBookingProfile(
      { ...bookingProfileVar(), bookingEmail: newBookingEmail },
      bookingProfileVar,
    );
  };
};

export const createSetBookingType = (bookingProfileVar) => {
  return (newBookingType) => {
    saveBookingProfile({ ...bookingProfileVar(), bookingType: newBookingType }, bookingProfileVar);
  };
};
